var map = {
	"app/core/masterComponent/pagemaster.module": [
		"./src/app/core/masterComponent/pagemaster.module.ts"
	],
	"app/dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"app/diretta-portale/diretta-portale.module": [
		"./src/app/diretta-portale/diretta-portale.module.ts"
	],
	"app/elenco-dirette/elenco-dirette.module": [
		"./src/app/elenco-dirette/elenco-dirette.module.ts",
		"elenco-dirette.module"
	],
	"app/match/match.module": [
		"./src/app/match/match.module.ts",
		"match.module"
	],
	"app/visite-dirette/visite-dirette.module": [
		"./src/app/visite-dirette/visite-dirette.module.ts",
		"visite-dirette.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main